export default __webpack_public_path__ + "static/media/hango-screenshot-04.65c6a472.png";